import { useNavigatePage } from "hooks/useNavigatePage";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useParams } from "react-router";
import { BtnWrapper, Page, PageWrapper, PaginationWrapper } from "./style";
const Pagination = ({ totalPages, pagingSize = 10 }) => {
  const nav = useNavigatePage();
  const { page } = useParams();

  // 10의자리 인덱스
  const [pageIndex, setPageIndex] = useState(Math.floor(page / pagingSize));
  const [pageLength, setPageLength] = useState(0);

  useEffect(() => {
    setPageLength(totalPages);
  }, [totalPages]);

  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });
  const hoverHandler = (e) => {
    const url = e.target.src;
    e.target.src = url.replace(".svg", "green.svg");
  };
  const outHandler = (e) => {
    const url = e.target.src;
    e.target.src = url.replace("green.svg", ".svg");
  };
  const navHandler = (to) => {
    nav("/news_events/" + to);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // 페이지 이동 ( < | > 누르는 경우)
  const pageIndexHandler = (dir) => {
    if (dir === "up") {
      if (pageIndex + 1 > pageLength / 10) return;
      nav("/news_events/" + (pageIndex + 1) * 10);
      setPageIndex(pageIndex + 1);
    } else {
      if (pageIndex - 1 < 0) return;
      nav("/news_events/" + (pageIndex - 1) * 10);
      setPageIndex(pageIndex - 1);
    }
  };

  // 끝 페이지 이동 ( << | >> 누르는 경우)
  const endPageHandler = (dir) => {
    if (dir === "up") {
      if (pageIndex + 1 > pageLength / 10) return;
      nav("/news_events/" + Math.floor(pageLength / 10) * 10);
      setPageIndex(Math.floor(pageLength / 10));
    } else {
      if (pageIndex - 1 < 0) return;
      nav("/news_events/" + 0);
      setPageIndex(0);
    }
  };

  const tempArr = new Array(pageLength).fill(0);
  return (
    <PaginationWrapper>
      <BtnWrapper pageLength={pageLength}>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/e281b7c120-Line-Medium.svg"
          alt=""
          onMouseEnter={hoverHandler}
          onMouseOut={outHandler}
          onClick={() => endPageHandler("down")}
        />
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/a431bc5020-Line-Medium.svg"
          alt=""
          onMouseEnter={hoverHandler}
          onMouseOut={outHandler}
          onClick={() => pageIndexHandler("down")}
        />
      </BtnWrapper>
      <PageWrapper>
        {isPc
          ? tempArr
              .map((v, idx) => (
                <Page key={idx} onClick={() => navHandler(idx)} isSelected={page * 1 === idx}>
                  {idx + 1}
                </Page>
              ))
              .slice(pageIndex * 10, (pageIndex + 1) * 10)
          : tempArr
              .map((v, idx) => (
                <Page key={idx} onClick={() => navHandler(idx)} isSelected={page * 1 === idx}>
                  {idx + 1}
                </Page>
              ))
              .slice(0, 5)}
      </PageWrapper>
      <BtnWrapper pageLength={pageLength}>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/5f8f58fd20-Line-Medium.svg"
          alt=""
          onMouseEnter={hoverHandler}
          onMouseOut={outHandler}
          onClick={() => pageIndexHandler("up")}
        />
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4d14ab4d20-Line-Medium.svg"
          alt=""
          onMouseEnter={hoverHandler}
          onMouseOut={outHandler}
          onClick={() => endPageHandler("up")}
        />
      </BtnWrapper>
    </PaginationWrapper>
  );
};

export default Pagination;
